/**
 * Helper to format tracking codes for Commandes, Tickets, and Devis consistently
 * Example outputs:
 *  - #codeC-14-09-2026-000001  (Commande)
 *  - #codeT-14-09-2026-000001  (Ticket)
 *  - #codeD-14-09-2026-000001  (Devis)
 */

function parseDateParts(date?: string): { d: string; m: string; y: string } {
  let d = '01', m = '01', y = String(new Date().getFullYear());
  if (date) {
    try {
      const parsed = new Date(date);
      if (!isNaN(parsed.getTime())) {
        d = String(parsed.getDate()).padStart(2, '0');
        m = String(parsed.getMonth() + 1).padStart(2, '0');
        y = String(parsed.getFullYear());
        return { d, m, y };
      }
    } catch { /* fallthrough */ }
  }
  const now = new Date();
  d = String(now.getDate()).padStart(2, '0');
  m = String(now.getMonth() + 1).padStart(2, '0');
  y = String(now.getFullYear());
  return { d, m, y };
}

export function formatCodeCommande(refCommande?: string, id?: any, date?: string): string {
  if (refCommande && refCommande.trim() !== '' && refCommande.startsWith('#codeC-')) {
    return refCommande;
  }
  if (refCommande && refCommande.trim() !== '') {
    return refCommande.startsWith('#') ? refCommande : `#${refCommande}`;
  }
  const { d, m, y } = parseDateParts(date);
  const num = String(id || 1).padStart(6, '0');
  return `#codeC-${d}-${m}-${y}-${num}`;
}

export function formatCodeTicket(refTicket?: string, id?: any, date?: string): string {
  if (refTicket && refTicket.trim() !== '' && refTicket.startsWith('#codeT-')) {
    return refTicket;
  }
  if (refTicket && refTicket.trim() !== '') {
    return refTicket.startsWith('#') ? refTicket : `#${refTicket}`;
  }
  const { d, m, y } = parseDateParts(date);
  const num = String(id || 1).padStart(6, '0');
  return `#codeT-${d}-${m}-${y}-${num}`;
}

export function formatCodeDevis(refDevis?: string, id?: any, date?: string): string {
  if (refDevis && refDevis.trim() !== '' && refDevis.startsWith('#codeD-')) {
    return refDevis;
  }
  if (refDevis && refDevis.trim() !== '') {
    return refDevis.startsWith('#') ? refDevis : `#${refDevis}`;
  }
  const { d, m, y } = parseDateParts(date);
  const num = String(id || 1).padStart(6, '0');
  return `#codeD-${d}-${m}-${y}-${num}`;
}
